module.exports = __webpack_public_path__ + "img/whats-app-logo.29a4fa0b.png";